<template>
  <div :class="{'is-process':isProcess}">
    <el-form label-position="top" label-width="90px">
      <el-form-item label="请选择该节点的办理人" prop="text" class="user-type">
        <div class="radio-sub-name">
          <div class="name">常用办理人</div>
          <div class="name">主管</div>
          <div class="name" v-if="isProcess">其他</div>
        </div>
        <el-radio-group v-model="nodeProps.assignedType" class="radio-group" @change="changeAssignedType(nodeProps.assignedType)">
          <el-radio v-for="(t,index) in approvalTypes" :label="t.type" :key="t.type" :class="'radio-'+index"><span class="radio-name">{{ t.name }}</span></el-radio>
        </el-radio-group>
        <div v-if="nodeProps.assignedType === 'ASSIGN_USER'">
          <!-- <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectUser" plain>选择成员</el-button>
          <org-items v-model="nodeProps.assignedUser"/> -->
          <el-select v-model="nodeProps.assignedUser" @click.native="selectUser" value-key="name"
                      class="select-u" placeholder="指定成员"
                      size="medium" multiple popper-class="hidden">
            <el-option v-for="(wc, index) in nodeProps.assignedUser" :label="wc.name" :key="index" :value="wc"></el-option>
          </el-select>
        </div>
        <div v-else-if="nodeProps.assignedType === 'NEW_OWNER'">
           <span class="item-desc">流程结束前最后处理的人</span>
        </div>
        <div v-else-if="nodeProps.assignedType === 'SELF_SELECT'">
          <el-radio-group size="mini" v-model="nodeProps.selfSelect.multiple" class="radio-group-person">
            <el-radio-button :label="false">自选一个人</el-radio-button>
            <el-radio-button :label="true">自选多个人</el-radio-button>
          </el-radio-group>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER_TOP'">
          <el-divider/>
          <el-form-item label="办理终点" prop="text" class="approve-end">
            <el-radio-group v-model="nodeProps.leaderTop.endCondition">
              <el-radio label="TOP">直到最上层主管</el-radio>
              <el-radio label="LEAVE">不超过发起人的</el-radio>
            </el-radio-group>
            <div class="approve-end-leave" v-if="nodeProps.leaderTop.endCondition === 'LEAVE'">
              <span>第 </span>
              <el-input-number :min="1" :max="20" :step="1" size="mini" v-model="nodeProps.leaderTop.level"/>
              <span> 级主管</span>
            </div>
          </el-form-item>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER'">
          <span class="item-desc">发起人直接上级将作为办理人进行办理</span>
        </div>
        <div v-else-if="nodeProps.assignedType === 'DEPT_LEADER'">
          <span class="item-desc">发起人的
            <el-select v-model="nodeProps.leader.level" size="small" class="select-level">
              <el-option label="第2级主管" :value="2"></el-option>
              <el-option label="第3级主管" :value="3"></el-option>
            </el-select>
          </span>
        </div>
        <!-- <div v-else-if="nodeProps.assignedType === 'LEADER'"  v-show="false">
          <el-divider/>
          <el-form-item label="指定主管" prop="text">
            <span>发起人的第 </span>
            <el-input-number :min="1" :max="20" :step="1" size="mini"
                             v-model="nodeProps.leader.level"></el-input-number>
            <span> 级主管</span>
            <div style="color: #409EFF; font-size: small;">👉 直接主管为 第 1 级主管</div>
          </el-form-item>
        </div> -->
        <div v-else-if="nodeProps.assignedType === 'ROLE'">
          <!-- <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectRole" round>选择系统角色</el-button>
          <org-items v-model="nodeProps.role"/> -->
          <el-select v-model="nodeProps.role" @click.native="selectRole" value-key="name"
                      class="select-u" placeholder="指定角色"
                      size="medium" multiple popper-class="hidden">
            <el-option v-for="(wc, index) in nodeProps.role" :label="wc.name" :key="index" :value="wc"></el-option>
          </el-select>
        </div>
        <div v-else-if="nodeProps.assignedType === 'FORM_USER'">
          <el-form-item label="选择表单联系人项" prop="text" class="approve-end">
            <el-select style="width: 80%;" size="small" v-model="nodeProps.formUser" placeholder="请选择包含联系人的表单项">
              <el-option v-for="op in forms" :label="op.title" :value="op.id" :key="op.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-else>
          <span class="item-desc">发起人自己作为办理人进行办理</span>
        </div>

      </el-form-item>

      <el-divider></el-divider>
      <!-- 发起人自己、自选不显示 -->
      <el-form-item label="办理人为空时" prop="text" class="line-mode"  v-if="!(nodeProps.assignedType =='SELF')">
        <el-radio-group v-model="nodeProps.nobody.handler">
          <el-radio label="TO_PASS"><span class="radio-name">自动通过</span></el-radio>
          <el-radio label="TO_REFUSE"><span class="radio-name">自动拒绝</span></el-radio>
          <el-radio label="TO_ADMIN"><span class="radio-name">自动转交管理员</span></el-radio>
          <el-radio label="TO_USER"><span class="radio-name">指定成员办理</span></el-radio>
        </el-radio-group>

        <div style="margin-top: 10px" v-if="nodeProps.nobody.handler === 'TO_USER'">
          <!-- <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectNoSetUser" plain>选择成员</el-button>
          <org-items v-model="nodeProps.nobody.assignedUser"/> -->
          <el-select v-model="nodeProps.nobody.assignedUser" @click.native="selectNoSetUser" value-key="name"
                      class="select-u" placeholder="指定成员办理"
                      size="medium" multiple popper-class="hidden">
            <el-option v-for="(wc, index) in nodeProps.nobody.assignedUser" :label="wc.name" :key="index" :value="wc"></el-option>
          </el-select>
        </div>

      </el-form-item>

      <div v-if="showMode">
        <el-divider/>
        <el-form-item label="多人办理时采用的办理方式" prop="text" class="approve-mode">
          <el-radio-group v-model="nodeProps.mode">
            <!-- <el-radio label="NEXT">会签 （按选择顺序办理，每个人必须同意）</el-radio> -->
            <el-radio label="AND"><span class="radio-name">会签（需要所有办理人都同意才可通过）</span></el-radio>
            <el-radio label="OR"><span class="radio-name">或签（其中一名办理人同意或拒绝即可）</span></el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <!-- <el-divider>高级设置</el-divider>
      <el-form-item label="✍ 办理同意时是否需要签字" prop="text">
        <el-switch inactive-text="不用" active-text="需要" v-model="nodeProps.sign"></el-switch>
        <el-tooltip class="item" effect="dark" content="如果全局设置了需要签字，则此处不生效" placement="top-start">
          <i class="el-icon-question" style="margin-left: 10px; font-size: medium; color: #b0b0b1"></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="⏱ 办理期限（为 0 则不生效）" prop="timeLimit">
        <el-input style="width: 180px;" placeholder="时长" size="small" type="number"
                  v-model="nodeProps.timeLimit.timeout.value">
          <el-select style="width: 75px;" v-model="nodeProps.timeLimit.timeout.unit" slot="append" placeholder="请选择">
            <el-option label="天" value="D"></el-option>
            <el-option label="小时" value="H"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="办理期限超时后执行" prop="level" v-if="nodeProps.timeLimit.timeout.value > 0">
        <el-radio-group v-model="nodeProps.timeLimit.handler.type">
          <el-radio label="PASS">自动通过</el-radio>
          <el-radio label="REFUSE">自动驳回</el-radio>
          <el-radio label="NOTIFY">发送提醒</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.timeLimit.handler.type === 'NOTIFY'">
          <div style="color:#409EEF; font-size: small">默认提醒当前办理人</div>
          <el-switch inactive-text="循环" active-text="一次" v-model="nodeProps.timeLimit.handler.notify.once"></el-switch>
          <span style="margin-left: 20px" v-if="!nodeProps.timeLimit.handler.notify.once">
							每隔
							<el-input-number :min="0" :max="10000" :step="1" size="mini"
                               v-model="nodeProps.timeLimit.handler.notify.hour"/>
							小时提醒一次
						</span>
        </div>
      </el-form-item>
      <el-form-item label="🙅‍ 如果办理被驳回 👇">
        <el-radio-group v-model="nodeProps.refuse.type">
          <el-radio label="TO_END">直接结束流程</el-radio>
          <el-radio label="TO_BEFORE">驳回到上级办理节点</el-radio>
          <el-radio label="TO_NODE">驳回到指定节点</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.refuse.type === 'TO_NODE'">
          <span>指定节点:</span>
          <el-select style="margin-left: 10px; width: 150px;" placeholder="选择跳转步骤" size="small" v-model="nodeProps.refuse.target">
            <el-option v-for="(node, i) in nodeOptions" :key="i" :label="node.name" :value="node.id"></el-option>
          </el-select>
        </div>

      </el-form-item> -->
    </el-form>
    <org-picker :title="pickerTitle" :multiple="multiple" ref="orgPicker" @ok="selected" />
  </div>
</template>

<script>
import OrgPicker from "@/components/OrgPicker";
import OrgItems from "../OrgItems";

export default {
  name: "ApprovalNodeConfig",
  components: {OrgPicker, OrgItems},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOrgSelect: false,
      multiple:false,
      orgPickerSelected: [],
      pickerTitle:'',
      orgPickerType: 'user',
      // approvalTypes: [
      //   {name: '直接上级', type: 'LEADER'},
      //   {name: '指定成员', type: 'ASSIGN_USER'},
      //   {name: '发起人自己', type: 'SELF'},
      //   {name: '发起人自选', type: 'SELF_SELECT'},
      //   {name: '角色', type: 'ROLE'},
      //   // {name: '指定人员', type: 'ASSIGN_USER'},
      //   // {name: '发起人自选', type: 'SELF_SELECT'},
      //   // {name: '连续多级主管', type: 'LEADER_TOP'},
      //   // {name: '主管', type: 'LEADER'},
      //   // {name: '角色', type: 'ROLE'},
      //   // {name: '发起人自己', type: 'SELF'},
      //   // {name: '表单内联系人', type: 'FORM_USER'}
      // ]
    }
  },
  computed: {
        // 审批流没有发起人自选
    approvalTypes(){
      if(this.isProcess){
        return [
          {name: '指定成员', type: 'ASSIGN_USER'},
          {name: '直接上级', type: 'LEADER'},
          {name: '最后归属人', type: 'NEW_OWNER'},// 右边3
          {name: '角色', type: 'ROLE'},
          {name: '部门主管', type: 'DEPT_LEADER'},// 右边2
        ]
      }else{
        return [
          {name: '指定成员', type: 'ASSIGN_USER'}, // 左边1
          {name: '直接上级', type: 'LEADER'},// 右边1
          {name: '发起人自己', type: 'SELF'}, // 左边2
          {name: '部门主管', type: 'DEPT_LEADER'},// 右边2
          {name: '发起人自选', type: 'SELF_SELECT'},// 左边3
          {name: '角色', type: 'ROLE'}, // 左边4
        ]
      }
    },
    nodeProps() {
      return this.$store.state.selectedNode.props
    },
    select() {
      return this.config.assignedUser || []
    },
    forms() {
      return this.$store.state.design.formItems.filter(f => {
        return f.name === 'UserPicker'
      })
    },
    // pickerTitle() {
    //   switch (this.orgPickerType) {
    //     case 'user':
    //       return '请选择成员';
    //     case 'role':
    //       return '请选择系统角色';
    //     default:
    //       return null;
    //   }
    // },
    nodeOptions() {
      let values = []
      const excType = ['ROOT', 'EMPTY', "CONDITION", "CONDITIONS", "CONCURRENT", "CONCURRENTS"]
      this.$store.state.nodeMap.forEach((v) => {
        if (excType.indexOf(v.type) === -1) {
          values.push({id: v.id, name: v.name})
        }
      })
      return values
    },
    showMode() {
      switch (this.nodeProps.assignedType) {
        case "ASSIGN_USER":
          return this.nodeProps.assignedUser.length > 1;
        case "SELF_SELECT":
          return this.nodeProps.selfSelect.multiple;
        case "LEADER_TOP":
          return this.nodeProps.formUser !== '';
        case "FORM_USER":
          return true;
        case "ROLE":
          return true;
        case "DEPT_LEADER":
          return true;
        default:
          return false;
      }
    }
  },
  methods: {
    
    // 指定成员
    selectUser() {
      this.pickerTitle = '指定成员'
      this.pickerType = 'user'
      this.multiple = true
      this.$refs.orgPicker.show(this.select,this.pickerType)
    },
    // 指定角色
    selectRole() {
      this.pickerTitle = '指定角色'
      this.pickerType = 'role'
      this.multiple = true
      this.$refs.orgPicker.show(this.nodeProps.role,this.pickerType)
    },
    // 指定人员审批
    selectNoSetUser() {
      this.pickerTitle = '指定成员办理'
      this.pickerType = 'noSet'
      this.multiple = false
      this.$refs.orgPicker.show(this.nodeProps.nobody.assignedUser,'user')
    },
    // 选中人员回显
    selected(value) {
      console.log(value)
      if(this.pickerType==='user'){
        let key  = 'assignedUser'
        this.$store.commit("updateSelectedNode",{key,value});
      }else if(this.pickerType==='role'){
        let key  = 'role'
        this.$store.commit("updateSelectedNode",{key,value});
      }else if(this.pickerType==='noSet'){
        let key  = 'assignedUser'
        this.$store.commit("updateSelectedNodeNobody",{key,value});
      }
      this.$bus.$emit('updateNodeText');
    },
    removeTag(item){

    },
    // 切换成员清空
    changeAssignedType(type){
      if (type !== 'ASSIGN_USER') {
        this.$store.commit("updateSelectedNode", { key: 'assignedUser', value: [] });
      }
      if (type !== 'ROLE') {
          this.$store.commit("updateSelectedNode", { key: 'role', value: [] });
      }
      if (type == 'DEPT_LEADER') {
          this.$store.commit("updateSelectedNode", { key: 'leader', value: {level:2} });
      }else if(type == 'LEADER') {
          this.$store.commit("updateSelectedNode", { key: 'leader', value: {level:1} });
      }
      this.$bus.$emit('updateNodeText');
    }
    // selectUser() {
    //   this.orgPickerSelected = this.select
    //   this.orgPickerType = 'user'
    //   this.$refs.orgPicker.show()
    // },
    // selectNoSetUser() {
    //   this.orgPickerSelected = this.config.nobody.assignedUser
    //   this.orgPickerType = 'user'
    //   this.$refs.orgPicker.show()
    // },
    // selectRole() {
    //   this.orgPickerSelected = this.select
    //   this.orgPickerType = 'role'
    //   this.$refs.orgPicker.show()
    // },
    // selected(select) {
    //   console.log(select)
    //   this.orgPickerSelected.length = 0
    //   select.forEach(val => this.orgPickerSelected.push(val))
    // },
    // removeOrgItem(index) {
    //   this.select.splice(index, 1)
    // }
  }
}
</script>

<style lang="scss" scoped>
.radio-sub-name{
  display: inline-flex;
  width: 360px;
  line-height: 1;
  .name{
    width: 50%;
  }
}
  .radio-name{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2F3030;
  }
.user-type {
  /deep/ .el-form-item__label {
    padding-bottom: 2px;

  }
  .radio-group{
    width: 360px;
  }
  /deep/ .el-radio {
    width: 100%;
    // margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 0;
    &.radio-0,
    &.radio-1,
    &.radio-2,
    &.radio-3,
    &.radio-4 {
      float: left;
      width: 50%;
    }
  }
}

/deep/ .line-mode {
  .el-form-item__label {
    padding-bottom: 14px;

  }
  .el-radio {
    width: 100%;
    margin: 0 0 10px 0;
  }
}

/deep/ .el-form-item__label {
  line-height: 25px;
  font-weight: bold;
  font-family: PingFang SC, PingFang SC;
  color: #2F3030;
}

/deep/ .approve-mode {
  .el-form-item__label {
    padding-bottom: 14px;

  }
  .el-radio {
    // float: left;
    width: 100%;
    display: block;
    // margin-top: 15px;
    margin-bottom: 10px;
  }
}

/deep/ .approve-end {
  position: relative;

  .el-radio-group {
    width: 160px;
  }

  .el-radio {
    margin-bottom: 5px;
    width: 100%;
  }

  .approve-end-leave {
    position: absolute;
    bottom: -5px;
    left: 150px;
  }
}

/deep/ .el-divider--horizontal {
  margin: 10px 0;
}
.radio-group-person{
  margin-right: 10px;
}
/deep/ .select-u{
  width: 100%;
}
.select-level{
  /deep/.el-input__inner{
    padding-left: 8px;
    font-size: 14px;
  }
}
.is-process{
  .radio-sub-name,
  .radio-group{
    width: 450px;
  }
  .user-type /deep/ {
    .el-radio.radio-0,
    .el-radio.radio-1,
    .el-radio.radio-2,
    .el-radio.radio-3,
    .el-radio.radio-4{
      width: 33.33%;
    }
  }
}
</style>
